export interface IntegrateAuthorityRequest {
  authorityType: string
  authorityNo: string
  targetAuthorityNo: string
}

export function IntegrateAuthorityRequestToJSON(
  value: IntegrateAuthorityRequest
): any {
  return {
    authority_type:
      value.authorityType !== '' ? value.authorityType : undefined,
    authority_no: value.authorityNo !== '' ? value.authorityNo : undefined,
    target_authority_no:
      value.targetAuthorityNo !== '' ? value.targetAuthorityNo : undefined
  }
}
